import React, { useState, useEffect } from "react";
import * as StyleDOMinfo from "../../../Components/Applicant-Tracking/Candidates/CandidateDetails/CandidateInfo.jsx";
import DynamicTextField from "../../../Common/Textfield/Textfield";
import TextInput from "../../../Common/TextInput/TextInput";
const VendorInfo = ({ selectedVendor, isEditingVendor, formik }) => {
  const [showPersonal, setShowPersonal] = useState(true);
  const [locationDetails, setLocationDetails] = useState(false);

  useEffect(() => {
    if (selectedVendor) {
      const initialValues = {
        email: selectedVendor?.email || "",
        nameOfVendor: selectedVendor?.name || "",
        contactPersonName: selectedVendor?.contact_person || "",
        contactDesignation: selectedVendor?.contact_designation || "",
        mobile: selectedVendor?.phone || "",
        country: selectedVendor?.country || "",
        state: selectedVendor?.state || "",
        city: selectedVendor?.city || "",
        address: selectedVendor?.address || "",
        // address2: selectedVendor?.address_2 || "",
        zipCode: selectedVendor?.zip_code || "",
        federalTax: selectedVendor?.federal_tax || "",
        bankName: selectedVendor?.bank_name || "",
        accountName: selectedVendor?.account_name || "",
        accountNumber: selectedVendor?.account_number || "",
        routingNumber: selectedVendor?.routing_number || "",
        natureOfAccount: selectedVendor?.account_nature || "",
        farcaCode: selectedVendor?.farca_reporting_code || "",
        exemptPayeeCode: selectedVendor?.exempt_payee_code || "",
      };
      formik.setValues(initialValues);
      formik.setTouched({});
    }
  }, [selectedVendor]);

  return (
    <div className="client-details-container">
      <div className="client-details-inner-container">
        <div className="candidate-information">
          <div className="detail-content">
            {isEditingVendor ? (
              <>
                <span
                  className="detail-label"
                  style={{
                    color: "#6a69eb",
                    fontSize: "20px",
                    fontWeight: "500",
                  }}
                >
                  Bank Details
                </span>
                <div className="bank-detail-inputs">
                  <DynamicTextField
                    label="Federal Tax"
                    name="federalTax"
                    placeholder="Enter your Federal Tax"
                    value={formik.values.federalTax}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.federalTax && formik.errors.federalTax
                    }
                    errorMessage={formik.errors.federalTax}
                    style={{ width: "100%" }}
                    // required={true}
                  />
                  <DynamicTextField
                    label="Bank Name"
                    name="bankName"
                    placeholder="Name of the bank"
                    value={formik.values.bankName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.bankName && formik.errors.bankName}
                    errorMessage={formik.errors.bankName}
                    style={{ width: "100%" }}
                    // required={true}
                  />
                  <DynamicTextField
                    label="Account Name"
                    name="accountName"
                    placeholder="Enter Your Account Name"
                    value={formik.values.accountName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.accountName && formik.errors.accountName
                    }
                    errorMessage={formik.errors.accountName}
                    style={{ width: "100%" }}
                    // required={true}
                  />
                  <DynamicTextField
                    label="Account Number"
                    name="accountNumber"
                    placeholder="Enter Your Account Number"
                    value={formik.values.accountNumber}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.accountNumber &&
                      formik.errors.accountNumber
                    }
                    errorMessage={formik.errors.accountNumber}
                    style={{ width: "100%" }}
                    // required={true}
                  />
                  <DynamicTextField
                    label="Routing Number"
                    name="routingNumber"
                    placeholder="Enter Your Routing Number"
                    value={formik.values.routingNumber}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.routingNumber &&
                      formik.errors.routingNumber
                    }
                    errorMessage={formik.errors.routingNumber}
                    style={{ width: "100%" }}
                    // required={true}
                  />
                  <DynamicTextField
                    label="Nature of Account"
                    name="natureOfAccount"
                    placeholder="Checking / Savings"
                    value={formik.values.natureOfAccount}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.natureOfAccount &&
                      formik.errors.natureOfAccount
                    }
                    errorMessage={formik.errors.natureOfAccount}
                    style={{ width: "100%" }}
                    // required={true}
                  />
                  <DynamicTextField
                    label="FARCA reporting code"
                    name="farcaCode"
                    placeholder="Enter FARCA reporting code (if any)"
                    value={formik.values.farcaCode}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.farcaCode && formik.errors.farcaCode}
                    errorMessage={formik.errors.farcaCode}
                    style={{ width: "100%" }}
                    // required={true}
                  />
                  <DynamicTextField
                    label="Exempt payee code"
                    name="exemptPayeeCode"
                    placeholder="Enter exempt payee code (if any)"
                    value={formik.values.exemptPayeeCode}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.exemptPayeeCode &&
                      formik.errors.exemptPayeeCode
                    }
                    errorMessage={formik.errors.exemptPayeeCode}
                    style={{ width: "100%" }}
                    // required={true}
                  />
                </div>
              </>
            ) : (
              <>
                <StyleDOMinfo.StyledInfoTabs
                  onClick={() => setShowPersonal((prev) => !prev)}
                >
                  Bank Details {showPersonal ? "▼" : "▶"}
                </StyleDOMinfo.StyledInfoTabs>
                {showPersonal && (
                  <StyleDOMinfo.InfoValue>
                    <div className="address-outer-container">
                      <div className="address-containers">
                        <label>Federal Tax:</label>
                        <div className="client-details-value">
                          {selectedVendor?.federal_tax || "N/A"}
                        </div>
                      </div>
                      <div className="address-containers">
                        <label>Bank Name:</label>
                        <div className="client-details-value">
                          {selectedVendor?.bank_name || "N/A"}
                        </div>
                      </div>
                      <div className="address-containers">
                        <label>Account Name:</label>
                        <div className="client-details-value">
                          {selectedVendor?.account_name || "N/A"}
                        </div>
                      </div>
                      <div className="address-containers">
                        <label>Account Number:</label>
                        <div className="client-details-value">
                          {selectedVendor?.account_number || "N/A"}
                        </div>
                      </div>
                      <div className="address-containers">
                        <label>Routing Number:</label>
                        <div className="client-details-value">
                          {selectedVendor?.routing_number || "N/A"}
                        </div>
                      </div>
                      <div className="address-containers">
                        <label>Nature of Account:</label>
                        <div className="client-details-value">
                          {selectedVendor?.account_nature || "N/A"}
                        </div>
                      </div>
                      <div className="address-containers">
                        <label>FARCA reporting code:</label>
                        <div className="client-details-value">
                          {selectedVendor?.farca_reporting_code || "N/A"}
                        </div>
                      </div>
                      <div className="address-containers">
                        <label>Exempt payee code:</label>
                        <div className="client-details-value">
                          {selectedVendor?.exempt_payee_code || "N/A"}
                        </div>
                      </div>
                    </div>
                  </StyleDOMinfo.InfoValue>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <div className="client-details-inner-container">
        <div className="candidate-information">
          <div className="detail-content">
            {isEditingVendor ? (
              <>
                <span
                  className="detail-label"
                  style={{
                    color: "#6a69eb",
                    fontSize: "20px",
                    fontWeight: "500",
                  }}
                >
                  Vendor Location Fields
                </span>
                <div className="location-inputs">
                  <TextInput
                    label="Address"
                    name="address"
                    placeholder="Enter your address"
                    value={formik.values.address}
                    // required={true}
                    onBlur={formik.handleBlur}
                    error={formik.touched.address && formik.errors.address}
                    errorMessage={formik.errors.address}
                    onChange={formik.handleChange}
                  />
                  <TextInput
                    label="City"
                    name="city"
                    placeholder="City"
                    value={formik.values.city}
                    // required={true}
                    onBlur={formik.handleBlur}
                    error={formik.touched.city && formik.errors.city}
                    errorMessage={formik.errors.city}
                    onChange={formik.handleChange}
                  />
                  <TextInput
                    label="State"
                    name="state"
                    placeholder="State"
                    value={formik.values.state}
                    // required={true}
                    onBlur={formik.handleBlur}
                    error={formik.touched.state && formik.errors.state}
                    errorMessage={formik.errors.state}
                    onChange={formik.handleChange}
                  />
                  <TextInput
                    label="Country"
                    name="country"
                    placeholder="Country"
                    value={formik.values.country}
                    // required={true}
                    onBlur={formik.handleBlur}
                    error={formik.touched.country && formik.errors.country}
                    errorMessage={formik.errors.country}
                    onChange={formik.handleChange}
                  />
                  <TextInput
                    label="Zipcode"
                    name="zipCode"
                    placeholder="Zipcode"
                    value={formik.values.zipCode}
                    // required={true}
                    onBlur={formik.handleBlur}
                    error={formik.touched.zipCode && formik.errors.zipCode}
                    errorMessage={formik.errors.zipCode}
                    onChange={formik.handleChange}
                  />
                </div>
              </>
            ) : (
              <>
                <StyleDOMinfo.StyledInfoTabs
                  onClick={() => setLocationDetails((prev) => !prev)}
                >
                  Vendor Location Details {locationDetails ? "▼" : "▶"}
                </StyleDOMinfo.StyledInfoTabs>
                {locationDetails && (
                  <StyleDOMinfo.InfoValue>
                    <div className="address-outer-container">
                      <div className="address-containers">
                        <label>Address:</label>
                        <div className="client-details-value">
                          {selectedVendor?.address || "N/A"}
                        </div>
                      </div>
                      <div className="address-containers">
                        <label>City:</label>
                        <div className="client-details-value">
                          {selectedVendor?.city || "N/A"}
                        </div>
                      </div>
                      <div className="address-containers">
                        <label>State:</label>
                        <div className="client-details-value">
                          {selectedVendor?.state || "N/A"}
                        </div>
                      </div>
                      <div className="address-containers">
                        <label>Country:</label>
                        <div className="client-details-value">
                          {selectedVendor?.country || "N/A"}
                        </div>
                      </div>
                      <div className="address-containers">
                        <label>Zipcode:</label>
                        <div className="client-details-value">
                          {selectedVendor?.zip_code || "N/A"}
                        </div>
                      </div>
                    </div>
                  </StyleDOMinfo.InfoValue>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorInfo;
